const IMPORT_CSV = 'server-sts/csv/IMPORT_CSV';
const IMPORT_CSV_SUCCESS = 'server-sts/csv/IMPORT_CSV_SUCCESS';
const IMPORT_CSV_FAIL = 'server-sts/csv/IMPORT_CSV_FAIL';

const EXPORT_CSV = 'server-sts/csv/EXPORT_CSV';
const EXPORT_CSV_SUCCESS = 'server-sts/csv/EXPORT_CSV_SUCCESS';
const EXPORT_CSV_FAIL = 'server-sts/csv/EXPORT_CSV_FAIL';


const LOAD_CALL_REASONS = 'server-sts/csv/LOAD_CALL_REASONS';
const LOAD_CALL_REASONS_SUCCESS = 'server-sts/csv/LOAD_CALL_REASONS_SUCCESS';
const LOAD_CALL_REASONS_FAIL = 'server-sts/csv/LOAD_CALL_REASONS_FAIL';


import _ from 'underscore';


const initialState = {
  loading: false,
  errorCSV: false,
  loaded: false,
  data: [],
  successCSV: false,
  crList: [],
  crSuccess: false,
  crFail: false,
  crLoading: false,
  errorNotice: false,
  successNotice: false,
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case 'IMPORT_NOTICE':
      return {
        ...state,
        loading: true
      };

    case 'IMPORT_NOTICE_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        successNotice: 'La base a été mise à jour',
        errorNotice: false
      };

    case 'IMPORT_NOTICE_FAIL':
      return {
        ...state,
        loading: false,
        loaded: false,
        errorNotice: action.error,
        successNotice: false,
      };

    case LOAD_CALL_REASONS:
      return {
        ...state,
        crLoading: true
      };

    case LOAD_CALL_REASONS_SUCCESS:
      return {
        ...state,
        crList: action.result,
        crSuccess: true,
        crLoading: false
      };

    case LOAD_CALL_REASONS_FAIL:
      return {
        ...state,
        loading: true,
        crFail: true,
        crLoading: false
      };

    case IMPORT_CSV:
      return {
        ...state,
        loading: true
      };

    case IMPORT_CSV_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        successCSV: 'La base a été mise à jour',
        errorCSV: false
      };

    case IMPORT_CSV_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        errorCSV: action.error,
        successCSV: false,
      };


    case EXPORT_CSV:
      return {
        ...state,
        loading: true
      };

    case EXPORT_CSV_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        successCSV: 'export réussi',
        errorCSV: false
      };

    case EXPORT_CSV_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        errorCSV: action.error,
        successCSV: false,
      };

    default:
      return state;
  }
}

export function importCSV(values) {
  return {
    types: [IMPORT_CSV, IMPORT_CSV_SUCCESS, IMPORT_CSV_FAIL],
    promise: (client) => client.post('/csv/importCSV', {
      data: { values: values }
    })
  };
}

export function importNotice(file) {


  return {
    types: ['IMPORT_NOTICE', 'IMPORT_NOTICE_SUCCESS', 'IMPORT_NOTICE_FAIL'],
    promise: (client) => {
      return client.post('/csv/importNotice', {
        attach: [{ key: 'file', value: file }]

      })
    }
  };
}


export function exportCSV(params, fiches, noPhoneProducts) {

  return {
    types: [EXPORT_CSV, EXPORT_CSV_SUCCESS, EXPORT_CSV_FAIL],
    promise: (client) => client.post('/csv/exportCSV', {
      data: { params, fiches, noPhoneProducts }
    })
  };
}

export function loadCr() {
  return {
    types: [LOAD_CALL_REASONS, LOAD_CALL_REASONS_SUCCESS, LOAD_CALL_REASONS_FAIL],
    promise: (client) => client.post('/csv/loadCr')
  };
}
